// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_REMOVE_BUYER = "Odstra\u0148 z\u00e1jemce";
export const BZ2_REPLY = "Odpov\u011bz";
export const BZ2_REPLY_TO_seller = "Odpov\u011bz prodejci (%(seller)s)";
export const BZ2_REVIEW_BUYER = "Ohodno\u0165 kupuj\u00edc\u00ed";
export const BZ2_REVIEW_SELLER = "Ohodno\u0165 prod\u00e1vaj\u00edc\u00ed";
